declare var AdviewAdsTag: any;
declare var dfpParams: any;

export class AdsRewarded {
    apiUrl: string = "https://access.wyborcza.pl/additionalAccess";

    nodeElements: NodeListOf<Element>;
    nodeSelector: string = "[data-rewarded-ads]";

    slotInstance: googletag.Slot | null = null;
    slotPosition: string = "019-TOPLAYER";

    logger = (...args: any) => {
        console.log("%cAdsRewarded", "color: #fed049", ...args);
    }

    init = () => {
        this.nodeElements = document.querySelectorAll(this.nodeSelector);

        if (!this.nodeElements?.length) return;

        this.initSlot();
    }

    initSlot = () => {
        // @ts-ignore
        window.googletag = window.googletag || { cmd: [] };

        const searchParams = new URLSearchParams(location.search);
        const slotUnitPath = searchParams.get("adsRewardedSlot");

        googletag.cmd.push(() => {
            this.slotInstance = googletag.defineOutOfPageSlot(
                slotUnitPath || `${dfpParams.prefix}/${this.slotPosition}`,
                googletag.enums.OutOfPageFormat.REWARDED
            );

            this.logger("initSlot", this.slotInstance);

            if (!this.slotInstance) return;

            this.slotInstance
                .setTargeting("kw", [...AdviewAdsTag.kwTargeting, "rewarded"])
                .setTargeting("pos", [this.slotPosition])
                .setTargeting("yb_ab", AdviewAdsTag._YB.ab())
                .setTargeting("domena", location.hostname)
                .setTargeting("dir", dfpParams.dir)
                .setTargeting("dx", dfpParams.dx);

            this.slotInstance.addService(googletag.pubads());

            googletag
                .pubads()
                .addEventListener("rewardedSlotReady", this.onReady)
                .addEventListener("rewardedSlotClosed", this.onClosed)
                .addEventListener("rewardedSlotGranted", this.onGranted);

            googletag.pubads().refresh([this.slotInstance]);
        });
    }

    destroySlot = () => {
        googletag.destroySlots([this.slotInstance!]);

        this.slotInstance = null;
    }

    onReady = (event: googletag.events.RewardedSlotReadyEvent) => {
        this.logger("onReady", event);

        this.nodeElements?.forEach((node) => {
            node.addEventListener("click", (e: Event) => {
                if (!this.slotInstance) return;

                e.preventDefault();
                e.stopPropagation();

                event.makeRewardedVisible();
            });
        })
    }

    onClosed = (event: googletag.events.RewardedSlotClosedEvent) => {
        this.logger("onClosed", event);

        this.destroySlot();
    }

    onGranted = async (event: googletag.events.RewardedSlotGrantedEvent) => {
        this.logger("onGranted", event);

        const res = await fetch(this.apiUrl, {
            method: "post",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: document.body.dataset.xx || ""
        })

        res?.status === 200 ? this.onSuccess() : this.onError();
    }

    onSuccess = () => {
        this.logger("onSuccess");

        location.reload();
    }

    onError = () => {
        this.logger("onError");

        this.destroySlot();
    }
}
